export default __webpack_public_path__ + "static/Byzantine-1de43d91fac60b60b4dcef7b1880c7a2.png";